// extracted by mini-css-extract-plugin
module.exports = {"group_wrapper":"RadioGroup_group_wrapper__G5P3Q","choice":"RadioGroup_choice__IeOpy","large":"RadioGroup_large__NXc2_"};